import { propertyConstants } from "../../constants/Public/property.constants";

const initialState = {
    property_list   : '',
    fetching        : false
};

export default function (state = initialState, action) {
    switch (action.type) {
        case propertyConstants.PROPERTY_REQUEST:
            return {
                ...state,
                fetching   : true,
                payload    : action.response
            };
        case propertyConstants.PROPERTY_SUCCESS:
            return {
                ...state,
                fetching: false,
                property_list: action.property_list,
                payload: action.response
            };
        case propertyConstants.PROPERTY_FAILURE:
            return {
                ...state,
                fetching: false
            };
        default:
            return state
    }
}